module.exports = __webpack_public_path__ + "media/src/images/page01_zu_worksheet0202-7f80c39f67cc7f07a7c37f55703a601a.gif";